export default {
  api: {
    url: 'https://graphql.wnwd.com'
  },
};
